import type { infer as zInfer } from "zod/v4";
import { object, string } from "zod/v4";

export const getBlueCherryIntegration = {
  name: "getBlueCherryIntegration" as const,
  input: object({}),
  output: object({
    blueCherryIntegration: object({
      companyCode: string(),
      environmentCode: string(),
    }).optional(),
  }),
};

export type BlueCherryIntegration = zInfer<
  typeof getBlueCherryIntegration.output
>;
